import moment from 'moment-timezone';
import { fetchS3JsonFile } from '../../../consumer_web/app/modules/components/AmexMarketingUtils/AmexUtils';

const MAINTENANCE_FOLDER_NAME = 'maintenance';
const MAINTENANCE_FILE_NAME = 'maintenance.json';

const ET_TIMEZONE = 'America/New_York';
const CONFIG_DATE_TIME_FORMAT = 'MMMM D, YYYY h:mm A';

export const fetchMaintenanceConfig = async (assetsBaseUrl) => {
  const data = await fetchS3JsonFile(
    assetsBaseUrl,
    MAINTENANCE_FOLDER_NAME,
    MAINTENANCE_FILE_NAME,
    true
  );
  return data?.maintenance ?? null;
};

const parseEtDateTime = (date, time) => {
  if (!date || !time) {
    return null;
  }
  const normalizedTime = time.replace(/\s*ET\s*$/i, '').trim();
  const parsed = moment.tz(`${date} ${normalizedTime}`, CONFIG_DATE_TIME_FORMAT, ET_TIMEZONE);
  return parsed.isValid() ? parsed : null;
};

const isMaintenancePageEnabled = (maintenance = {}, now = moment()) => {
  if (!maintenance?.enabled) {
    return false;
  }

  const current = moment(now);
  const start = parseEtDateTime(maintenance.startDate, maintenance.startTime);
  const end = parseEtDateTime(maintenance.endDate, maintenance.endTime);
  if ((start && current.isSameOrAfter(start)) && (end && current.isBefore(end))) {
    return true;
  }

  return false;
};

export default isMaintenancePageEnabled;
